export const TRANSPORT_OPTIONS = [
    {value: 'Van / Caminhonete', label: 'Van / Caminhonete'},
    {value: 'Caminhão Toco', label: 'Caminhão Toco'},
    {value: 'Caminhão Truck', label: 'Caminhão Truck'},
    {value: 'Carreta', label: 'Carreta'}
];